import React, { Component } from "react";

import { IFilter } from "@formant/core/model/IFilter";
import { LayoutType } from "@formant/core/model/LayoutType";
import { Button } from "@formant/ui-kit";

import { observeStore } from "../../stores";
import { Heading1 } from "../common/Heading1";
import * as styles from "./NoResults.scss";

export interface INoResultsProps {
    offline?: boolean;
    filter?: IFilter;
    layoutType?: LayoutType;
    onChangeFilter?: (filter: IFilter) => void;
}

export class NoResults extends Component<INoResultsProps> {
    public render() {
        const { filter, offline } = this.props;
        const { hideInactiveStreams } = observeStore;
        return (
            <div className={styles["no-results"]}>
                <div className={styles.container}>
                    {offline ? (
                        <>
                            <Heading1 className={styles.heading}>
                                Device offline
                            </Heading1>
                            <p>
                                Make sure your device is powered on and has an
                                internet connection.
                            </p>
                        </>
                    ) : (
                        <>
                            <Heading1 className={styles.heading}>
                                No Modules
                            </Heading1>
                            <p>
                                It's quiet in here. Add a module using the
                                Customize button at the top of the screen.
                            </p>
                        </>
                    )}
                    <>
                        <>
                            <Heading1 className={styles.heading}>
                                No Results
                            </Heading1>
                            <p>
                                This filter does not match any data in your
                                organization.
                            </p>
                            <p>
                                Remove terms from the filter to make it less
                                restrictive.
                            </p>
                        </>
                        {(Object.keys(filter || {}).length ||
                            hideInactiveStreams) && (
                            <p>
                                <Button onClick={this.onClearFilters}>
                                    Clear all filters now
                                </Button>
                            </p>
                        )}
                    </>
                </div>
            </div>
        );
    }

    private onClearFilters = () => {
        observeStore.hideInactiveStreams = false;
        this.props.onChangeFilter?.({});
    };
}
